import { CircularProgress, Divider, IconButton } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import ArchiveIcon from "@material-ui/icons/Archive";
import DeleteIcon from "@material-ui/icons/Delete";
import { Field, Form, Formik } from "formik";
import { Checkbox, TextField } from "formik-material-ui";
import React from "react";
import styled from "styled-components";
import ProceduresContext from "./ProceduresContext";
import moment from 'moment';
import GridTemplateColumns from './GridTemplateColumns';
import FormikSimpleSelect from '../common/FormikSimpleSelect';
import { connect } from 'react-redux';


const SubHeader = styled.div`
  padding-top: 10px;
  display: grid;
  grid-template-columns: ${GridTemplateColumns};
  padding-right: 10px;
  padding-bottom: 10px;
  align-items: center;
`;

const SubHeaderText = styled.div`
  color: black;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  text-align: left;
  width: 95%;
`;

const SelectContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-items: flex-end;
  // margin-block-start: auto;
  margin-top: 16px;
`;

const Container = styled.div`
 background:#E8E8E8;
`

const MetadataContainerStyled = styled.div`
    position: absolute;
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 grey;
    background-color: #fff;
    margin-top: 10px;
    cursor: pointer;
    min-width: 110px;
    z-index:1;
    padding: 10px;
    width:700px;
    max-height: 500px;
    overflow-y: scroll;
`

const SdnStyled = styled.div`
  position: relative;
`

const MetadataMenuItemStyled = styled.div`
   padding: 10px;
   font-size: 14px;
   font-stretch: normal;
   font-style: normal;
   line-height: 1.43;
   letter-spacing: normal;
   text-align: left;
   color: rgba(0, 0, 0, 0.86);
`;

const MetadataHeadingStyled = styled.div`
  color: gray;
`

const MetadataMenuHeadingStyled = styled.div`
  display: flex;
  font-weight: 600;
`

const MetadataItemListStyled = styled.div`
  display: flex;
`
const MetadataMenuItemProjStyled = styled.div`
  width: 15%;
`
const MetadataMenuItemSDNStyled = styled.div`
  width: 30%;
  margin: 0 0 20px 0;
`
const MetadataMenuItemRevStyled = styled.div`
  width: 12%;
`
const MetadataMenuItemTitleStyled = styled.div`
  width: 43%;
`
function validateUrl(value) {
  let error;
  if (value) {
    const pattern = new RegExp(
      "(?:(?:https?|ftp)://)" + // protocol identifier
      "(?:\\S+(?::\\S*)?@)?" +     // user:pass authentication
      "(?:" + // IP address exclusion
      "(?!(?:10|127)(?:\\.\\d{1,3}){3})" + // private & local networks
      "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
      "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
      "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
      "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
      "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
      "|" +
      "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" + // host name
      "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" + // domain name
      "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" + // TLD identifier
      ")" +
      "(?::\\d{2,5})?" + // port number
      "(?:[/?#](?:\\S*[^\\s!\"'()*,-.:;<>?\\[\\]_`{|}~]|))?" // resource path, excluding a trailing punctuation mark
      , "gi"
    );

    error = !!pattern.test(value) ? undefined : 'Invalid URL';
  }
  return error;
}

class ProceduresEditableListItem extends React.Component {
  constructor(props) {
    const { procedure = {} } = props;
    super(props);
    this.state = {
      newEntry: {
        sdn: procedure.sdn || '',
        name: procedure.name || '',
        effectiveDate: procedure.effectiveDate || '',
        url: procedure.url || '',
        rev: procedure.rev || '',
        categoryId: procedure.categoryId || ''
      },
      metaData: [],
      isMetadataVisible: false
    }
  }

  render() {
    const { procedure = {}, context, selectedFunction, myRRDocs } = this.props;
    const sdnMetadata = myRRDocs

    if (procedure.projectId && !procedure.categoryId && context.projectCategory) {
      procedure.categoryName = context.projectCategory.name;
      procedure.categoryId = context.projectCategory.id;
    }
    const categoryButtonTitleValues = (context.selectedFunctionDetails && context.selectedFunctionDetails.categories) ? context.selectedFunctionDetails.categories.filter(category => !category.isProject).map(category => ({ title: category.name, value: category.id })) : []


    const handleNewEntryChange = (e) => {
      if (typeof e != 'object') {
        // e is not an object in case of catagory is changed
        const selectedrow = {
          ...this.state.newEntry,

          categoryId: e
        }

        this.setState({ ...this.state, newEntry: selectedrow });
        return;
      }

      // filter the result for metadata on sdn changed
      let temp = [];
      let isMetadataVisible = false;
      if (e.target.name == 'sdn' && e.target.value.length >= 3 && sdnMetadata) {
        isMetadataVisible = true;
        temp = sdnMetadata.filter((sdnMetadataRow) => {
          // return sdnMetadataRow.sdn.includes(e.target.value) // taking too much of time
          return sdnMetadataRow.sdn.startsWith(e.target.value); // fast execution
          // return sdnMetadataRow.sdn.indexOf(e.target.value) // taking too much of time
        })
      }

      const selectedrow = {
        ...this.state.newEntry,
        // sdn: e.target.value ? e.target.value : ''
        [e.target.name]: e.target.value ? e.target.value : ''
      }

      this.setState({ ...this.state, newEntry: selectedrow, metaData: temp, isMetadataVisible: isMetadataVisible });

    }

    const handleMetadataSelect = (id) => {
      const temp = sdnMetadata.filter((sdnMetadataRow) => {
        return sdnMetadataRow.id == id
      })

      const selectedrow = {
        ...this.state.newEntry,
        sdn: temp[0].sdn,
        name: temp[0].documentTitle,
        effectiveDate: temp[0].effectiveDate,
        url: temp[0].documentLink,
        rev: temp[0].documentRevision
      }

      // TODO we need to update all fields as per selected option instead for only sdn
      this.setState({ ...this.state, newEntry: selectedrow, isMetadataVisible: false });
    }

    return (
      <Container>
        <Formik
          initialValues={{ ...procedure, effectiveDate: procedure.effectiveDate ? moment(procedure.effectiveDate).format('YYYY-MM-DD') : procedure.effectiveDate }}
          onSubmit={(values, actions) => {
            const procedure = { ...values, ...this.state.newEntry, functionId: selectedFunction.id };
            const initailProcedureValues = context.procedures.procedureBeingEdited;
            if (procedure.isNew || !procedure.id) {
              if ((initailProcedureValues && procedure.rev === initailProcedureValues.rev) || procedure.id === '') {
                context.saveProcedure(procedure, success => {
                  if (success) {
                    context.editProcedure(null);
                  } else {
                    actions.setSubmitting(false);
                  }
                });
              } else {
                context.confirmRevision(procedure); actions.setSubmitting(false);
              }
            } else {
              if ((initailProcedureValues && procedure.rev === initailProcedureValues.rev) || (initailProcedureValues && procedure.projectId !== null)) {
                initailProcedureValues.archived = true;
                context.saveProcedure(procedure, success => {
                  if (!success) {
                    actions.setSubmitting(false);
                  } else {
                    context.editProcedure(null);
                  }
                });
              } else {
                context.confirmRevision(procedure); actions.setSubmitting(false);
              }

            }
          }}

          render={(formProps, errors, touched, validateField, validateForm) => (
            <Form>
              <SubHeader>

                <div />
                <SubHeaderText>
                  <SdnStyled>
                    <Field
                      name="sdn"
                      component={TextField}
                      fullWidth label="SDN"
                      onChange={handleNewEntryChange}
                      value={this.state.newEntry.sdn}
                    />
                    {!!this.state.isMetadataVisible && !!this.state.metaData.length && <MetadataContainerStyled>
                      <MetadataMenuHeadingStyled>
                        <MetadataMenuItemProjStyled>Project No.</MetadataMenuItemProjStyled>
                        <MetadataMenuItemSDNStyled>SDN</MetadataMenuItemSDNStyled>
                        <MetadataMenuItemRevStyled>Rev</MetadataMenuItemRevStyled>
                        <MetadataMenuItemTitleStyled>Title</MetadataMenuItemTitleStyled>
                        {/* <MetadataMenuItemRevStyled>Rev No</MetadataMenuItemRevStyled>
                        <MetadataMenuItemProjStyled>Effective</MetadataMenuItemProjStyled>
                        <MetadataMenuItemProjStyled>Link</MetadataMenuItemProjStyled> */}

                      </MetadataMenuHeadingStyled>
                      {this.state.metaData.map((item) => {
                        return <MetadataItemListStyled key={item.id} onClick={() => handleMetadataSelect(item.id)}>
                          <MetadataMenuItemProjStyled> {item.projectNumber}</MetadataMenuItemProjStyled>
                          <MetadataMenuItemSDNStyled> {item.sdn}</MetadataMenuItemSDNStyled>
                          <MetadataMenuItemRevStyled> {item.documentRevision}</MetadataMenuItemRevStyled>
                          <MetadataMenuItemTitleStyled> {item.documentTitle}</MetadataMenuItemTitleStyled>
                          {/* <MetadataMenuItemTitleStyled> {item.documentVersionNumber}</MetadataMenuItemTitleStyled>
                      <MetadataMenuItemTitleStyled> {item.effectiveDate}</MetadataMenuItemTitleStyled>
                      <MetadataMenuItemTitleStyled> {item.documentLink}</MetadataMenuItemTitleStyled> */}
                        </MetadataItemListStyled>
                      })}
                    </MetadataContainerStyled>
                    }
                  </SdnStyled>
                </SubHeaderText>
                <SubHeaderText>
                  <Field
                    name="name"
                    component={TextField}
                    label="Procedure Name"
                    fullWidth
                    onChange={handleNewEntryChange}
                    value={this.state.newEntry.name}
                  />
                </SubHeaderText>
                <SelectContainer>
                  {procedure.projectId ?
                    'PROJECT' :
                    <FormikSimpleSelect
                      buttonTitleValues={categoryButtonTitleValues}
                      setFieldValue={formProps.setFieldValue}
                      setFieldTouched={formProps.setFieldTouched}
                      field="categoryId"
                      name="categoryId"
                      //value={formProps.values.categoryId}
                      onValueChanged={handleNewEntryChange}
                      value={this.state.newEntry.categoryId}
                    />
                  }
                </SelectContainer>
                <SubHeaderText>
                  <Field
                    name="rev"
                    component={TextField}
                    label="Rev"
                    fullWidth
                    onChange={handleNewEntryChange}
                    value={this.state.newEntry.rev} />
                </SubHeaderText>
                <SubHeaderText>
                  <Field
                    type="date"
                    name="effectiveDate"
                    label={formProps.values.effectiveDate ? "Effective Date" : " "}
                    component={TextField}
                    fullWidth
                    onChange={handleNewEntryChange}
                    value={moment(this.state.newEntry.effectiveDate).format('YYYY-MM-DD')}
                  />
                </SubHeaderText>

                <SubHeaderText>
                  <Field
                    name="url"
                    component={TextField}
                    label="URL"
                    validate={validateUrl}
                    fullWidth
                    onChange={handleNewEntryChange}
                    value={this.state.newEntry.url}
                  />
                </SubHeaderText>
                <SubHeaderText>
                </SubHeaderText>
                {!formProps.isSubmitting &&
                  <>
                    <div>
                      {/* <IconButton disabled={!(formProps.values.effectiveDate && formProps.values.rev && formProps.values.name && formProps.values.sdn && (formProps.values.categoryId || formProps.values.projectId))} */}
                      <IconButton disabled={!(this.state.newEntry.effectiveDate && this.state.newEntry.rev && this.state.newEntry.name && this.state.newEntry.sdn && (this.state.newEntry.categoryId || formProps.values.projectId))}
                        type="submit"
                        color="primary">
                        <CheckIcon />
                      </IconButton>
                    </div>
                    <div>
                      <IconButton color="primary"
                        onClick={() => context.editProcedure(null)}
                      >
                        <CloseIcon

                        />
                      </IconButton>
                    </div>
                  </>
                }
                {formProps.isSubmitting &&
                  <>
                    <div />
                    <CircularProgress size={20} />
                  </>
                }
                <div>
                  {procedure.id && procedure.isNew && (
                    <IconButton color="primary" onClick={() => {

                      const procedure = { ...formProps.values, ...this.state.newEntry, functionId: selectedFunction.id, delete: true };
                      context.saveProcedure(procedure, success => {
                        if (success) {
                          context.editProcedure(null);
                        }
                      });

                    }}>
                      <DeleteIcon />
                    </IconButton>
                  )}
                  {procedure.id && !procedure.isNew && (
                    <IconButton color="primary" onClick={() => {

                      const procedure = { ...formProps.values, ...this.state.newEntry, functionId: selectedFunction.id, archived: true };
                      context.confirmArchive(procedure);

                    }}>
                      <ArchiveIcon />
                    </IconButton>
                  )}
                </div>

              </SubHeader>
              <Divider />
            </Form>
          )}
        />
      </Container>
    );
  }
}

export default ProceduresEditableListItem = connect((state) => {
  const { functions } = state;
  return {
    myRRDocs: functions.myRRDocs || []
  };
}, {})(ProceduresEditableListItem);